<template>
  <div class="w-full">
    <dash-edit-header v-if="form.type === 'dash'" v-model="form_name" active-index="3" />
    <form-edit-header v-else v-model="form_name" :flowable="form.type === 'flowform'" active-index="3" />
    <div class="w-4/5 m-auto border bg-white p-5 overflow-auto" style="height: calc(100vh - 108px);">
      <el-button type="primary" icon="el-icon-plus" @click="openDialog">新建权限组</el-button>
      <div v-for="_group in groups" :key="_group.id" class="fx-publish-auth-group-item">
        <div class="item-title">
          <span class="item-title-text">{{ _group.name }}</span>
          <button v-if="_group.id > 0" class="text-sm text-sky-500" @click="onEdit(_group)">编辑</button>
        </div>
        <div class="item-describe">{{ _group.desc }}</div>
        <member-list-pane v-model="_group.value" :data="_group.members" />
      </div>
    </div>
    <el-dialog
      :key="timer" class="create_group" append-to-body :close-on-click-modal="false" title="新建权限组"
      :visible.sync="visible"
    >
      <el-container>
        <el-main>
          <div class="h-[380px]">
            <el-tabs tab-position="left" style="height: 100%;">
              <el-tab-pane label="名称信息">
                <div class="px-3">
                  <div class="h-10 leading-10 text-sm text-gray-400">可设置权限组名称和描述信息</div>
                  <div class="mb-2">
                    <el-input v-model="group.name" placeholder="填写权限组名称" />
                  </div>
                  <div>
                    <el-input v-model="group.desc" resize="none" :rows="5" type="textarea" placeholder="填写描述信息" />
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="操作权限">
                <div class="px-3">
                  <div class="h-10 leading-10 text-sm text-gray-400">可对流程和数据进行哪些操作</div>
                  <div class="grid grid-cols-3">
                    <div class="h-8">
                      <el-checkbox v-model="group.dataPerms.read">查看</el-checkbox>
                    </div>
                    <div class="h-8">
                      <el-checkbox v-model="group.dataPerms.create">添加</el-checkbox>
                    </div>
                    <div class="h-8">
                      <el-checkbox v-model="group.dataPerms.update">编辑</el-checkbox>
                    </div>
                    <div class="h-8">
                      <el-checkbox v-model="group.dataPerms.delete">删除</el-checkbox>
                    </div>
                    <div class="h-8">
                      <el-checkbox v-model="group.dataPerms.export">导出</el-checkbox>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="数据权限">
                <div class="px-3">
                  <div class="h-10 leading-10 text-sm text-gray-400">可以查看到哪些数据</div>
                  <div>
                    筛选出符合以下
                    <span class="combo">
                      <el-select v-model="group.dataAuth.rel" class="simple">
                        <el-option value="and" label="所有" />
                        <el-option value="or" label="任一" />
                      </el-select>
                    </span>

                    条件的数据
                  </div>

                  <div>
                    <el-popover
                      v-model="menuVisible"
                      placement="bottom-start"
                      width="200"
                      :append-to-body="false"
                      popper-class="popper-class"
                    >
                      <div>
                        <el-menu v-if="menuVisible" @select="handleSelect">
                          <el-menu-item
                            v-for="(widget,index) in form.fields" :key="index" :index="widget.name"
                            style="height: 32px;line-height: 32px;"
                          >
                            {{ widget.text }}
                          </el-menu-item>
                        </el-menu>
                      </div>
                      <span slot="reference" class="cursor-pointer text-sky-600 text-sm h-9 leading-9">
                        <i class="bi bi-plus text-base" />
                        添加条件
                      </span>
                    </el-popover>
                  </div>
                  <ul class="field-list">
                    <li v-for="(item, index) in group.dataAuth.cond" :key="index" class="field-item main-field group">
                      <div
                        class="field-label relative  h-10 w-full flex flex-row items-center justify-between group-hover:bg-[#ebf8fb] px-2"
                      >
                        <div class="grow flex flex-row items-center ">
                          <div class="w-1/3 field-name overflow-hidden truncate">
                            {{ form.fields.find(field => field.name === item.field).text }}
                          </div>
                          <div class="w-1/3">
                            <el-select v-model="item.method" class="simple">
                              <el-option value="eq" label="等于" />
                              <el-option value="neq" label="不等于" />
                              <el-option value="empty" label="为空" />
                              <el-option value="not-empty" label="不为空" />
                            </el-select>
                          </div>
                        </div>

                        <div class="w-10">
                          <i
                            class="bi bi-trash mx-1 cursor-pointer"
                            @click="() => {group.dataAuth.cond.splice(index, 1)}"
                          />
                        </div>
                      </div>
                      <div
                        v-if="item.method === 'eq' || item.method === 'neq'"
                        class="w-full group-hover:bg-[#ebf8fb] px-2 pb-1"
                      >
                        <el-select
                          v-model="item.value"
                          class="w-full"
                          size="mini"
                          multiple
                          filterable
                          allow-create
                          default-first-option
                        >
                          <el-option
                            v-for="_item in Object.keys(options).includes(form.fields.find(field => field.name === item.field ).type) ? options[form.fields.find(field => field.name === item.field ).type] : []"
                            :key="_item.value"
                            :label="_item.name"
                            :value="_item.value"
                          />
                        </el-select>
                      </div>
                    </li>
                  </ul>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-main>
        <el-footer>
          <div class="px-4 py-[14px] w-full text-right border-t">
            <el-button type="primary" size="small" :loading="btnLoading" @click="onGroupAdd">确定</el-button>
          </div>
        </el-footer>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import zroute from '@/ziggy'
import MemberListPane from '@/components/MemberListPane'
import Layout from '../../Shared/Layout'
import FormEditHeader from '../../components/FormEditHeader'
import axios from 'axios'
import DashEditHeader from '../../components/DashEditHeader'
import _ from 'lodash'

export default {
  components: {
    DashEditHeader,
    MemberListPane,
    FormEditHeader,
  },
  layout: Layout,
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      timer: Date.now(),
      group: {
        name: '',
        desc: '',
        dataPerms: {},
        dataAuth: {
          rel: 'and',
          cond: [],
        },

      },
      options: {
        dept: [{name: '当前用户所在部门', value: 0}, {name: '当前用户及下级部门', value: 1}],
        user: [{name: '当前用户', value: 0}],
      },
      menuVisible: false,
      visible: false,
      form_name: this.form.name,
      form_id: zroute().params.form_id,
      dash_id: zroute().params.dash_id,
      app_id: zroute().params.app_id,
      groups: this.form.authgroup_members.map(item => ({
        ...item,
        value: item.members.map(member => member.type + '_' + member.id),
      })),
      btnLoading: false,
    }
  },
  watch: {
    groups: {
      handler(val) {
        var data = {}
        val.map(group => {
          data[group.id] = group.value
        })
        console.log('groups changed', val, data)
        axios.post(zroute('app.form.publish.update', {
          form_id: this.form_id ? this.form_id : this.dash_id,
          app_id: this.app_id,
        }), {
          members: data,
        }).then(res => {
          console.log('publish update', res)
        }).catch(err => {
          console.log('publish update error', err)
        })
      },
      deep: true,
    },
  },
  created() {
  },
  methods: {
    openDialog() {
      this.group = {
        name: '',
        desc: '',
        dataPerms: {},
        dataAuth: {
          rel: 'and',
          cond: [],
        },
      }
      this.timer = Date.now()
      this.visible = true
    },
    onEdit(group) {
      console.log('onEdit', group)
      this.group = _.cloneDeep(group)
      this.timer = Date.now()
      this.visible = true
    },
    onGroupAdd() {
      // var perms = {}
      // this.group.dataPerms.map(item => {
      //   perms[item] = true
      // })
      this.btnLoading = true
      let data = {
        name: this.group.name,
        desc: this.group.desc,
        dataPerms: this.group.dataPerms,
        dataAuth: {
          cond: this.group.dataAuth.cond.map(item => {
            let widget = this.form.fields.find(field => field.name === item.field)
            if (widget.type === 'dept') {
              item.hasCurrentDept = item.value.includes(0)
              item.hasCurrentCascadeDept = item.value.includes(1)
            } else if (widget.type === 'user') {
              item.hasCurrentUser = item.value.includes(0)
            }
            return item
          }), rel: this.group.dataAuth.rel,
        },
      }
      if (this.group.id) {
        data.id = this.group.id
      }
      console.log('onGroupAdd', data)
      axios.post(zroute(this.group.id ? 'app.form.authgroup.update' : 'app.form.authgroup.create', {
        form_id: this.form_id,
        app_id: this.app_id,
      }), data).then(res => {
        this.btnLoading = false
        this.visible = false
        this.$message.success('操作成功')
        console.log('authgroup add', res)
      }).catch(err => {
        console.log('authgroup add error', err)
      })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath, this.data, this.widgets)
      this.group.dataAuth.cond.push({
        field: key,
        method: 'eq',
        value: [],
      })
      this.menuVisible = false
    },
    handleCopyText() {
      // 创建一个 Input标签
      const cInput = document.createElement('input')
      cInput.value = this.$refs.demoInput.value
      document.body.appendChild(cInput)
      cInput.select() // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('Copy')
      this.$message.success('复制成功')
      /// 复制成功后再将构造的标签 移除
      cInput.remove()
    },
  },
}
</script>
<style lang="scss" scoped>

.fx-publish-auth-group-item {
  padding-top: 32px;

  .el-tag {
    margin-left: 5px;
    margin-top: 5px;
  }

  .item-describe {
    margin-bottom: 4px;
    color: #91a1b7;
    font-size: 12px;
    line-height: 18px;
  }

  .item-title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    line-height: 22px;

    .item-title-text {
      display: block;
      -webkit-box-flex: 1;
      -ms-flex: auto;
      flex: auto;
      margin-right: 50px;
      font-weight: 600;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.create_group {
  ::v-deep .el-dialog__body {
    padding: 0;

    .el-main {
      padding: 0;

      .el-menu {
        max-height: 300px;
        overflow: auto;
        border-right: 0;
      }

      .el-tabs__content {
        height: 100%;
        overflow-y: auto;
      }

    }

    .el-footer {
      padding: 0;
    }
  }
}
</style>
